import qs from 'qs';

/**
 * Appends the query parameters by stringifying the given object.
 *
 * @param {string} baseUrl Url for which the query params is to be attached.
 * @param {Object} params Key-Value pair that needs to be converted to query params.
 */
export function addQueryParameters(baseUrl, params) {
  const queryString = qs.stringify(params);

  return queryString ? baseUrl + '?' + queryString : baseUrl;
}

export const extractQueryParams = (url) => {
  const queryParams = qs.parse(url);
  return queryParams;
}


// WEBPACK FOOTER //
// ./src/utils/url.js